export default "__VITE_ASSET__Dq6fs$pc__"